module.exports = __webpack_public_path__ + "img/16.3e80fef2.png";